import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import { CardV2 as Card } from '@feathr/components';
import { Goal } from '@feathr/extender/components';

function GoalsTwoPointOh(): JSX.Element {
  return (
    <Card width={'wide'}>
      <Card.Header title={'Goals 2.0'} />
      <Card.Content>
        <Goal />
      </Card.Content>
    </Card>
  );
}

export default observer(GoalsTwoPointOh);
